import { workingHoursMessages } from 'src/features/workingHours/utils/messages';
import { DAY_OF_WEEK } from 'src/features/workingHours/utils/types';

export const DAY_OF_WEEK_TRANSLATIONS_MAP = {
    [DAY_OF_WEEK.MONDAY]: workingHoursMessages.monday,
    [DAY_OF_WEEK.TUESDAY]: workingHoursMessages.tuesday,
    [DAY_OF_WEEK.WEDNESDAY]: workingHoursMessages.wednesday,
    [DAY_OF_WEEK.THURSDAY]: workingHoursMessages.thursday,
    [DAY_OF_WEEK.FRIDAY]: workingHoursMessages.friday,
    [DAY_OF_WEEK.SATURDAY]: workingHoursMessages.saturday,
    [DAY_OF_WEEK.SUNDAY]: workingHoursMessages.sunday,
};
